import React from "react";
import HandicapFields from "./HandicapFields";

const HandicapInputs = ({
  scoringType,
  setScoringType,
  handicapBase,
  setHandicapBase,
  handicapPercentage,
  setHandicapPercentage,
  handicapMax,
  setHandicapMax,
  errorMessages,
  scoringName,
}) => {
  return (
    <HandicapFields
      scoringType={scoringType}
      setScoringType={setScoringType}
      handicapBase={handicapBase}
      setHandicapBase={setHandicapBase}
      handicapPercentage={handicapPercentage}
      setHandicapPercentage={setHandicapPercentage}
      handicapMax={handicapMax}
      setHandicapMax={setHandicapMax}
      errorMessages={errorMessages}
      scoringName={scoringName}
    />
  );
};

export default HandicapInputs;
